<template>
  <BaseButton
    :disabled="disabled || showCopiedMessage"
    :color="color"
    @click="copyCode"
    v-test="'_base-copy-button'"
  >
    {{ showCopiedMessage
        ? $t('custom_booking_widget.copied')
        : $t('custom_booking_widget.copy_to_clipboard') }}
  </BaseButton>
</template>

<script
  setup
  lang="ts"
>
import { ref } from 'vue';

interface CopyButtonProps {
  disabled?: boolean;
  color?: 'primary' | 'inverted';
  value: string;
}

const props = withDefaults(defineProps<CopyButtonProps>(), {
  color: 'primary',
  disabled: false,
});

const emit = defineEmits(['copy']);

const showCopiedMessage = ref(false);

const copyCode = () => {
  const text = props.value;

  if (text) {
    showCopiedMessage.value = true;

    if (navigator.clipboard) {
      navigator.clipboard.writeText(text).catch(() => {
        httpFallbackCopy(text);
      });
    } else {
      httpFallbackCopy(text);
    }

    setTimeout(() => {
      showCopiedMessage.value = false;
    }, 3000);

    emit('copy');
  }
};

const httpFallbackCopy = (text: string) => {
  const textArea = document.createElement('textarea');
  textArea.value = text;
  textArea.style.position = 'fixed';
  textArea.style.opacity = '0';
  document.body.appendChild(textArea);
  textArea.select();
  document.execCommand('copy');
  document.body.removeChild(textArea);
};
</script>
